import axios from "../axiosInstance";

const CouponAPI = {
  addDetails: (payload) => axios.post("coupons/", payload),

  getList: (params) => axios.get(`coupons/`, { params }),

  getSingleDetails: (id) => axios.get(`coupons/${id}`),

  updateDetails: (id, payload) => axios.put(`coupons/${id}`, payload),

  updateStatus: (id) => axios.patch(`coupons/${id}/status`),

  visibilityStatus: (id) => axios.patch(`coupons/${id}/visibility`),

  deleteItem: (id) => axios.delete(`coupons/${id}`),
};

export default CouponAPI;
